var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.011,
    height: 25.545,
    viewBox: "0 0 20.011 25.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jpg-svgrepo-com",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14199",
    "data-name": "Trazado 14199",
    d: "M48.6,0H32.842V25.545H52.853V4.257Z",
    transform: "translate(-32.842)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_468",
    "data-name": "Grupo 468",
    transform: "translate(4.892 5.199)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1614",
    "data-name": "Rect\\xE1ngulo 1614",
    width: 10.101,
    height: 10.101,
    fill: "#38a3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14200",
    "data-name": "Trazado 14200",
    d: "M98.813,99.607l-2.006,3.385-3.264-5.508L90.9,101.94v2.631H101V103.3Z",
    transform: "translate(-90.902 -94.469)",
    fill: "#007934"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14201",
    "data-name": "Trazado 14201",
    d: "M49.255,2.129H32.842V0H48.6Z",
    transform: "translate(-32.842)",
    fill: "#38a3ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_469",
    "data-name": "Grupo 469",
    transform: "translate(4.613 18.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14202",
    "data-name": "Trazado 14202",
    d: "M88.158,231.2a2.677,2.677,0,0,1-.567-.058V230.3l.188.037a1.058,1.058,0,0,0,.216.021.442.442,0,0,0,.387-.163,1,1,0,0,0,.116-.559v-3.741h1.1v3.647a1.87,1.87,0,0,1-.359,1.243A1.338,1.338,0,0,1,88.158,231.2Z",
    transform: "translate(-87.591 -225.835)",
    fill: "#a4a9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14203",
    "data-name": "Trazado 14203",
    d: "M124.689,227.178a1.354,1.354,0,0,1-.4,1.047,1.612,1.612,0,0,1-1.135.369h-.307v1.341h-1.092v-4.042h1.4a1.71,1.71,0,0,1,1.15.335A1.193,1.193,0,0,1,124.689,227.178Zm-1.842.525h.2a.543.543,0,0,0,.391-.138.5.5,0,0,0,.145-.382q0-.409-.454-.409h-.282v.929Z",
    transform: "translate(-118.877 -225.834)",
    fill: "#a4a9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14204",
    "data-name": "Trazado 14204",
    d: "M164.22,226.936h1.745v2.179a4.8,4.8,0,0,1-1.562.243,1.888,1.888,0,0,1-1.445-.542,2.17,2.17,0,0,1-.51-1.546,2.03,2.03,0,0,1,.559-1.524,2.148,2.148,0,0,1,1.565-.545,3.47,3.47,0,0,1,.72.072,3.05,3.05,0,0,1,.59.182l-.346.857a2.137,2.137,0,0,0-.96-.216.912.912,0,0,0-.74.311,1.346,1.346,0,0,0-.261.889,1.363,1.363,0,0,0,.236.864.82.82,0,0,0,.682.3,2,2,0,0,0,.448-.047v-.633h-.722v-.843Z",
    transform: "translate(-156.141 -225.202)",
    fill: "#a4a9ad"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14205",
    "data-name": "Trazado 14205",
    d: "M219.821,4.257h4.257L219.821,0Z",
    transform: "translate(-204.067)",
    fill: "#d1d3d3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.c1e61180fd89955abcf706ebb41c0a02.svg";
export { ForwardRef as ReactComponent };